// ShopHelten - Terms & Conditions checkbox at the cart
$(document).ready(function () {
    $("body").on(
        "click",
        '[name="checkout"], [name="goto_pp"], [name="goto_gc"]',
        function () {
            if ($("#agree").is(":checked") || $("#agree_main_cart").is(":checked")) {
                $(this).submit();
            } else {
                alert(
                    "Du skal acceptere handelbetingelserne."
                );
                return false;
            }
        }
    );

  // Custom for this theme's "Slide-in" cart
   $('[name="checkout-link"]').click((event) => {
     event.preventDefault();

     if ($("#agree").is(":checked") || $("#agree_main_cart").is(":checked")) {
         window.location.href = $(event.target).attr("href");
      } else {
          alert(
              "Du skal acceptere handelbetingelserne."
          );
          return false;
      }
   });

  // Click handler for switching between variants
  $('body').on(
    "click",
    'button.product__chip',
    function (evt) {
      // Hide all SKU and Barcode/EAN
      $(".product__barcode").hide();

      // Now show selected variant's SKU and Barcode/EAN
      var barcode = $(evt.currentTarget).data("barcode");
      console.log("target", $(evt.currentTarget));
      $(`.barcode-${barcode}`).show();
    }
  );

  // Product options - Klaviyo Back-in-stock hide/show
  $('.product__chip').click(function () {
    console.log("Check if out of stock..", $(this).hasClass('soldout'));
        if ($(this).hasClass('soldout')) {
            $('.btn.klaviyo-bis-trigger').css('display', 'flex');
        } else {
            $('.btn.klaviyo-bis-trigger').css('display', 'none');
        }
    });
});